import { css } from '@emotion/react';
import { useMatch } from '@tanstack/react-location';
import { SetupTextConnect } from '@frontend/schedule';

export default function TextConnectSetup() {
  const {
    params: { locationId },
  } = useMatch();
  return (
    <div
      css={css({
        margin: 'auto',
      })}
    >
      <SetupTextConnect locationId={locationId} showInstructionLink={false} />
    </div>
  );
}
